export enum ActivityTypes {
	COMMENT = "COMMENT",
	HISTORY = "HISTORY",
}
